import * as Yup from 'yup';

export const passValidationSchema = Yup.object().shape({
  templateUuid: Yup.string().required('Pass template is required'),

  extId: Yup.string().when(['barcode', 'nfcEnabled', 'nfcSource'], {
    is: (
      barcode: { enabled?: boolean; source?: string },
      nfcEnabled: boolean,
      nfcSource: string
    ) =>
      (barcode?.enabled && barcode?.source === 'extId') ||
      (nfcEnabled && nfcSource === 'extId'),
    then: (schema) =>
      schema.required(
        'External ID is required when used as barcode or NFC source'
      ),
  }),

  barcode: Yup.object().shape({
    enabled: Yup.boolean(),
    type: Yup.string()
      .nullable()
      .when('enabled', {
        is: true,
        then: (schema) => schema.required('Barcode type is required'),
      }),
    source: Yup.string()
      .nullable()
      .when('enabled', {
        is: true,
        then: (schema) => schema.required('Barcode source is required'),
      }),
    value: Yup.string().when(['enabled', 'source'], {
      is: (enabled: boolean, source: string) => enabled && source === 'custom',
      then: (schema) => schema.required('Barcode value is required'),
    }),
  }),

  nfcCustomValue: Yup.string().when(['nfcEnabled', 'nfcSource'], {
    is: (nfcEnabled: boolean, nfcSource: string) =>
      nfcEnabled && nfcSource === 'custom',
    then: (schema) => schema.required('NFC value is required'),
  }),

  expiryDate: Yup.string(),
  expiryTime: Yup.string().when('expiryDate', {
    is: (val: string) => !!val,
    then: (schema) =>
      schema.required('Expiry time is required when date is set'),
  }),
});

export interface TemplateFieldDef {
  id: string;
  label: string;
}

export const validatePassFields = (
  fieldValues: Record<string, string | number>,
  fields: TemplateFieldDef[]
): Record<string, string> => {
  const errors: Record<string, string> = {};
  fields.forEach((field) => {
    const val = field.id == null ? '' : String(fieldValues[field.id] ?? '');
    if (field.id && !val.trim()) {
      errors[`fieldValues.${field.id}`] =
        `${field.label || field.id} is required`;
    } else if (field.id && val) {
      const anchorHrefMatch = val.match(/<a\s+href=['"](.*?)['"]/);
      if (
        anchorHrefMatch &&
        anchorHrefMatch[1] &&
        !/^(https?:\/\/|mailto:|tel:)/i.test(anchorHrefMatch[1])
      ) {
        errors[`fieldValues.${field.id}`] =
          `${field.label || field.id}: URL must start with https://, http://, mailto: or tel:`;
      }
    }
  });
  return errors;
};
